import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cbe0d6d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search-input-container"
};
const _hoisted_2 = ["disabled"];
const _hoisted_3 = {
  class: "search-autocomplete-container"
};
const _hoisted_4 = {
  key: 0,
  class: "search-autocomplete"
};
const _hoisted_5 = {
  key: 0,
  class: "spinner-container"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner"
}, null, -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "no-results"
}, "No results", -1));
const _hoisted_10 = [_hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _directive_click_outside = _resolveDirective("click-outside");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("input", {
    class: "c-input",
    style: {
      "width": "100%"
    },
    placeholder: "Search for Maps, Charts, and Data",
    autocomplete: "off",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.search = $event),
    disabled: _ctx.isDisabled,
    onKeyup: [_cache[1] || (_cache[1] = _withKeys(
    //@ts-ignore
    (...args) => _ctx.doSearch && _ctx.doSearch(...args), ["enter"])), _cache[2] || (_cache[2] = _withKeys(
    //@ts-ignore
    (...args) => _ctx.resetSearchInput && _ctx.resetSearchInput(...args), ["esc"]))]
  }, null, 40, _hoisted_2), [[_vModelText, _ctx.search]]), _createElementVNode("div", _hoisted_3, [_ctx.showResults ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings, (cfg, idx) => {
    return _openBlock(), _createElementBlock("div", {
      key: `search_${idx}`
    }, [_createElementVNode("h4", null, _toDisplayString(cfg.title), 1), cfg.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : !(cfg.data.length > 0) ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 2
    }, _renderList(cfg.data, (item, i) => {
      return _openBlock(), _createElementBlock("div", {
        key: `item_${idx}_${i}`
      }, [_createVNode(_component_router_link, {
        to: item.to,
        onClick: () => _ctx.onClick(cfg, item)
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.label), 1)]),
        _: 2
      }, 1032, ["to", "onClick"])]);
    }), 128))]);
  }), 128))])) : _createCommentVNode("", true)])])), [[_directive_click_outside, _ctx.resetSearchInput]]);
}